import { PEP_STATUS } from '../constants';

export const checkSuspectedPEP = (pepStatus) => {
  return pepStatus === PEP_STATUS.SuspectedPEP;
};

export const checkIdVerificationAttemptsMaxed = (verificationResult) => {
  return verificationResult?.links?.[0]?.rel === 'TooManyAttempts' ?? false;
};

export const scrollWindowToTop = () => {
  window.scrollTo({
    top: 0,
    behavior: 'smooth',
  });
};
